import React from "react";
import connect from "Shared/connect";
import { setFeedback } from "SiteLayout/GenericFeedbackBar/action-creators";
import { translate } from "Shared/translate";
import { on } from "SiteLayout/Root";
import { logout } from "../Account/action-creators";
import TabInEditModeHandler from "Shared/TabInEditModeHandler";
import { logoutGtm } from "../TrackingInformation";
function secToMs(sec) {
    return sec * 1000;
}
function minToMs(min) {
    return secToMs(min * 60);
}
const WARNING_LOGOUT_TIME = secToMs(45);
let timeLeft = WARNING_LOGOUT_TIME;
class AutomaticLogout extends React.Component {
    constructor(props) {
        super(props);
        this.resetAutomaticLogout = () => {
            clearTimeout(this.logoutTimer);
            if (this.isWithinLogoutWarningPeriod()) {
                this.logoutWarningAborted();
            }
            if (!this.props.currentUser.isLoggedIn || !this.hasAutomaticLogout()) {
                /*
                  Flawed logic?
                  This will still start the automatic logout on another tab were this.hasAutomaticLogout() is true
                  And this tab will be logged out as well, it will just not show the the notification banner.
                */
                return;
            }
            if (!this.tabInEditModeHandler.anyTabInEditMode()) {
                this.setLogoutTimer();
            }
        };
        this.setTabInEditModeHandlerRef = (c) => {
            this.tabInEditModeHandler = c;
        };
        this.autoMaticLogoutTime = minToMs(this.props.automaticLogout || 30);
    }
    componentDidMount() {
        on("click", this.resetAutomaticLogout);
        if (this.props.currentUser.isLoggedIn &&
            !this.tabInEditModeHandler.anyTabInEditMode()) {
            this.setLogoutTimer();
        }
    }
    componentDidUpdate(prevProps) {
        if (!this.props.currentPage.isLoading &&
            prevProps.currentPage.isLoading &&
            this.props.currentUser.isLoggedIn) {
            this.resetAutomaticLogout();
        }
    }
    hasAutomaticLogout() {
        return (!(this.props.currentPage.componentName.indexOf("DeliveryApplication") >= 0) &&
            !(this.props.currentPage.componentName.indexOf("PantryReportPage") >= 0));
    }
    logoutWarningAborted() {
        this.props.setFeedback({
            text: translate("/Account/LogoutWarningAborted"),
            type: "success",
        });
        timeLeft = WARNING_LOGOUT_TIME;
        clearInterval(this.warningInterval);
    }
    isWithinLogoutWarningPeriod() {
        return timeLeft !== 0 && timeLeft < WARNING_LOGOUT_TIME;
    }
    setLogoutTimer() {
        this.logoutTimer = setTimeout(() => {
            if (!this.tabInEditModeHandler.anyTabInEditMode()) {
                this.setWarningInterval();
            }
        }, this.autoMaticLogoutTime - WARNING_LOGOUT_TIME);
    }
    setWarningInterval() {
        if (!this.props.currentUser.isLoggedIn) {
            clearInterval(this.warningInterval);
            return;
        }
        timeLeft = WARNING_LOGOUT_TIME;
        const INTERVAL = secToMs(1);
        const unitText = translate("/Account/LogoutWarningUnit");
        this.warningInterval = setInterval(() => {
            timeLeft -= INTERVAL;
            if (this.tabInEditModeHandler.anyTabInEditMode()) {
                this.logoutWarningAborted();
            }
            else {
                this.props.setFeedback({
                    text: `${translate("/Account/LogoutWarning")} : ${timeLeft / INTERVAL} ${unitText}`,
                    type: "error",
                });
                if (timeLeft <= 0) {
                    this.noTimeLeftDoLogout();
                }
            }
        }, INTERVAL);
    }
    noTimeLeftDoLogout() {
        var _a, _b;
        clearTimeout(this.logoutTimer);
        clearInterval(this.warningInterval);
        this.props.setFeedback({
            text: translate("/Account/YouHaveBeenOutloggedDueToInactivity"),
            type: "error",
            timeout: minToMs(120),
        });
        if (!((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.currentUser) === null || _b === void 0 ? void 0 : _b.isImpersonating)) {
            logoutGtm('Username/Password', null, null);
        }
        window.location.href = "/Logout/OktaLogout";
    }
    render() {
        return React.createElement(TabInEditModeHandler, { setref: this.setTabInEditModeHandlerRef });
    }
}
export default connect((state) => ({
    currentPage: state.currentPage,
    automaticLogout: state.appShellData.siteSettings.automaticLogout,
    currentUser: state.currentUser,
}), (dispatch) => ({
    setFeedback: (data) => dispatch(setFeedback(data)),
    logout: () => dispatch(logout()),
}))(AutomaticLogout);
